import algoliasearch from "algoliasearch";

export default algoliasearch(
  "EKEGGUH63H",
  "MTYxNmZmYzhhMTFkNjI2NjcwZDFhZTM0ZmRmYjliY2U2MTQ3ZGJjMDgxY2M4YWE1ODA0YTJjZDQ5OTkyZmUwM3ZhbGlkVW50aWw9NDcyOTQyNjk1NQ==",
);
